import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { useKitCopy } from "./use-kit-copy";

export interface TaskLanguageOption {
  code: string;
  name: string;
  displayName?: string;
  flag?: string;
}

/**
 * Language picker of a task (setup screen or header). Shows the flag and
 * display name when the language list has them; loading and empty states
 * are disabled entries.
 */
export function TaskLanguageSelect({
  value,
  onChange,
  languages,
  isLoading = false,
  placeholder,
  className,
  id,
  testId,
}: {
  value: string;
  onChange: (code: string) => void;
  languages: TaskLanguageOption[];
  isLoading?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
  testId?: string;
}) {
  const { copy } = useKitCopy();
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger id={id} data-testid={testId} className={cn("h-11 bg-surface", className)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {isLoading ? (
          <SelectItem value="__loading__" disabled>
            {copy.languageLoading}
          </SelectItem>
        ) : languages.length === 0 ? (
          <SelectItem value="__none__" disabled>
            {copy.languageEmpty}
          </SelectItem>
        ) : (
          languages.map((language) => {
            const label = language.displayName || language.name;
            return (
              <SelectItem key={language.code} value={language.code}>
                {language.flag ? `${language.flag} ${label}` : label}
              </SelectItem>
            );
          })
        )}
      </SelectContent>
    </Select>
  );
}
